import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SvgIcon from '../svg-icon/svg-icon'
import { Card, CardContent, CardHeader, CardMeta, CardDescription, Image, Button } from 'semantic-ui-react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import './index.scss'

import userAvatar from '../../../assets/images/new-images/user-avatar.png';
import { eventActions, commonActions } from '../../../actions';
import axios from 'axios';
import { BASE_URL } from '../../../config/config';
import { formatIsoMilisecondOnlyTime, formatIsoMilisecondsWithoutTime, getDay, formatIsoMiliseconds, replaceSpaceInName, feedTimeAgo, month_names_short, number_formatter, getTwelveHoursTime, getFormattedDate2 } from '../../../common/helperMethods';
import default_image from '../../../assets/images/add-event-default.png'

const RightSideBar = (props) => {
    const [eventFilter, setEventFilter] = useState('upcomingEvents');
    const [eventsData, setEventData] = useState([]);
    const history = useHistory();
    const [networkData, setNetworkData] = useState([]);
    const [trendingData, setTrendingData] = useState([]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    /*  const StayConnectedSlides = [
         {
             id: 1,
             image: EventCard,
             name: 'Intersolar South America',
         },
         {
             id: 2,
             image: EventCard,
             name: 'European Conference on Optical Communication (ECOC 2024)',
         },
         {
             id: 3,
             image: EventCard,
             name: 'What you need to know about the International Conference in Mongolia...',
         },
         {
             id: 4,
             image: EventCard,
             name: 'What you need to know about the International Conference in Mongolia...',
         },
         {
             id: 5,
             image: EventCard,
             name: 'European Conference on Optical Communication (ECOC 2024)',
         },
         {
             id: 6,
             image: EventCard,
             name: 'Intersolar South America',
         }
     ]
  */


    useEffect(() => {
        const { eventPagination, setEventPagination, getAllEvent } = props;
        eventPagination.start = 0;
        eventPagination.size = 5;
        setEventPagination(eventPagination);
        getAllEvent(eventFilter)

        let post_link = `${BASE_URL}/api/post/promotional`;
        console.log('props.industry ', props.industry)
        if (props.industry != undefined && props.industry != '' && props.industry != null) {
            post_link = `${BASE_URL}/api/post/promotional?industryId=${props.industry}`;

        }

        axios.get(post_link, {
            "from": 0,
            "size": 5
        }).then((response) => {
            const { data } = response.data
            let a = [];
            if (data.rows.length > 0) {
                for (let i in data.rows) {
                    if (i <= 3) {
                        a.push(data.rows[i])
                    }
                }
            }
            setNetworkData(a)


        }).finally(() => {
            //  setLoading(false)
        })

        if (props.industry == "") {
            getTrending();
        }

    }, [])

    useEffect(() => {
        if (props.industry != "" && props.industry != undefined) {
            getTrending();
        }


    }, [props.industry])

    const getTrending = () => {
        axios.get(`${BASE_URL}/api/v2/topics/trending/${props.industry}`, {
            "from": 0,
            "size": 5
        }).then((response) => {
            const { data } = response.data
            if (response.data.success == true) {
                if (data.length > 0) {
                    setTrendingData(data)
                }
            }
        }).finally(() => {
            //  setLoading(false)
        })

    }


    useEffect(() => {
        const eventData = props.allEventCollection
        const upcoming_event = [];
        if (eventData != undefined) {
            const validEvents = eventData.filter(item => item != null);
            if (validEvents.length > 0) {
                validEvents.forEach(item => {
                    item.eventStartDate = isNaN(item.startDate) ? item.startDate : getFormattedDate2(+item.startDate);
                    item.eventStarTime = (item.startDate) ? getTwelveHoursTime(+item.startDate) : '';
                    item.eventStartDay = getDay(+item.startDate);
                    item.eventEndDate = isNaN(item.endDate) ? item.endDate : getFormattedDate2(+item.endDate);
                    item.eventEndTime = (item.endDate) ? getTwelveHoursTime(+item.endDate) : '';
                    item.eventEndDay = getDay(+item.endDate);
                    item.EventDate = new Date(parseInt(item.startDate)).getDate()
                    item.EventMonth = month_names_short[new Date(parseInt(item.endDate)).getMonth()];
                    item.eventStartDate = (item.eventStartDate != 'Invalid Date') ? item.eventStartDate : '';
                    item.eventEndDate = (item.eventEndDate != 'Invalid Date') ? item.eventEndDate : '';

                    item.eventStarTime = (item.eventStarTime != 'Invalid Date') ? item.eventStarTime : '';
                    item.eventEndTime = (item.eventEndTime != 'Invalid Date') ? item.eventEndTime : '';

                    // conditional filtering of events - start
                    if (eventFilter == 'upcomingEvents') {
                        upcoming_event.push(item);
                    }
                    // conditional filtering of events - end
                });
            }
        }

        setEventData(upcoming_event)
    }, [props.allEventCollection])

    const render_slider = (eventdata) => {
        const { image, eventName } = eventdata || {};
        if (image != undefined) {
            if (Array.isArray(image) && image.length > 0) {
                return (
                    <img src={image[0]} className='w-100' alt={eventName} title={eventName} onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = default_image;
                    }} />
                )
            } else if (!Array.isArray(image)) {
                return (
                    <img src={image} alt={eventName} className='w-100' title={eventName} onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = default_image;
                    }} />
                )
            } else {
                return (
                    <img src={default_image} alt={eventName} className='w-100' title={eventName} />
                )
            }
        } else {
            return (
                <img src={default_image} className='w-100' alt={eventName} title={eventName} />
            )
        }
    }

    const gotoEvents = () => {
        history.push('/event-list');
    }

    const event_details = (id, name) => {
        history.push(`/events/${replaceSpaceInName(name)}/${id}`);
    }

    const gotofeed = () => {
        if (props.auth) {
            history.push('/mappes-network');
        } else {
            history.push('/otp-login');
        }
    }


    const gotofeed_details = (data) => {
        history.push(`/feed/post/${data.id}`);
    }

    const render_user_avatar = (postdata) => {
        const { user } = postdata || {};
        if (user != undefined && user.image != undefined) {
            return (
                <Image
                    floated='left'
                    size='mini'
                    src={user.image}
                />
            )
        } else {
            return (
                <Image
                    floated='left'
                    size='mini'
                    src={userAvatar}
                />
            )
        }
    }

    const gotoProduct = (item) => {
        console.log('item ', item)
        if (item.name != undefined && item.id != undefined) {
            history.push(`/product/${replaceSpaceInName(item.name)}/${item.id}`);
        }
    }

    const render_trending = (slide) => {
        if (slide.name != undefined && slide.count != undefined) {
            return (
                <li className='cursor-pointer' onClick={() => gotoProduct(slide)}>#{slide.name}
                    {slide.count != '0' &&
                        <div className='views-right'> {number_formatter(slide.count)}
                            <SvgIcon name='eye-icon' viewbox="0 0 10 7" />
                        </div>
                    }
                </li>
            )
        }
    }

    const render_text = (text) => {
        if (text != undefined && text != '') {
            let t = text.replace(/<\/?[^>]+(>|$)/g, "").substr(0, 250)
            // first word of articleText should be capital 
            t = t.charAt(0).toUpperCase() + t.slice(1);
            return t;
        }
        return '';
    }


    const render_address = (event) => {
        const { location, eventLocation } = event || {};
        if (eventLocation) {
            if (!eventLocation.city && !eventLocation.country) {
                return (
                    <span>{location}</span>
                )
            }

            return (
                <span>{eventLocation.city} {eventLocation.city && eventLocation.country ? `,  ` : ''} {eventLocation.country ? `  ${eventLocation.country}` : ''} {eventLocation.pincode ? `-  ${eventLocation.pincode}` : ''}</span>
            )
        } else {
            return (
                <span>{location}</span>
            )
        }
    }
    return (
        <div className='innerpages-right-section'>
            {trendingData.length > 0 &&
                <div className='right-cards'>
                    <div className='titles'><div className='titles-left'>Trending Topics</div></div>
                    <div className='card-body'>
                        <ul className='trending-topic-list'>
                            {trendingData && trendingData.length > 0 && trendingData.map(slide =>
                                (render_trending(slide))
                            )}
                        </ul>
                    </div>
                </div>
            }
            {(props.show == 'post' || props.show == 'both') && <>
                {networkData.length > 0 &&
                    <div className='right-cards'>
                        <div className='titles'><div className='titles-left'>Latest Posts</div>
                            <Button onClick={() => gotofeed()}><SvgIcon name='chevron-right' viewbox="0 0 8 14" /></Button>
                        </div>
                        <div className='card-body'>
                            {networkData && networkData.map(slide =>
                                <Card className='cursor-pointer' onClick={() => gotofeed_details(slide)}>
                                    <CardContent>
                                        {render_user_avatar(slide)}
                                        <CardHeader>{slide.user ? slide.user.displayName : ''}</CardHeader>
                                        <CardMeta><span className='time-col'>{slide != undefined && slide.added != undefined ? feedTimeAgo(slide.added) : ''}</span></CardMeta>
                                        <CardDescription dangerouslySetInnerHTML={{ __html: render_text(slide.text) }}>
                                        </CardDescription>
                                        <CardDescription>
                                            {slide.hashtag}
                                        </CardDescription>
                                    </CardContent>
                                    <CardContent extra className='card-action'>
                                        <div className='left-actions'>
                                            <ul>
                                                <li><SvgIcon name='thumbsup-icon' viewbox="0 0 18 19" />{slide.like_count}</li>
                                                <li><SvgIcon name='comment-icon' viewbox="0 0 18 18" />{slide.comment_count}</li>
                                                <li><SvgIcon name='share-icon' viewbox="0 0 18 19" /></li>
                                            </ul>
                                        </div>
                                        <div className='right-actions'>
                                            <SvgIcon name='cube-icon' viewbox="0 0 18 20" />
                                        </div>
                                    </CardContent>
                                </Card>

                            )}
                        </div>
                    </div>
                }
            </>
            }

            {(props.show == 'event' || props.show == 'both') && eventsData.length > 0 &&
                <div className='right-cards'>
                    <div className='titles'><div className='titles-left'>Upcoming Events</div><Button onClick={() => gotoEvents()}><SvgIcon name='chevron-right' viewbox="0 0 8 14" /></Button></div>
                    <div className='card-body'>
                        {/* <Slider {...settings} > */}

                        <Swiper
                            className='event-card-slider'
                            modules={[Pagination, Autoplay]}
                            pagination={{ clickable: true }}
                            speed={300}
                            autoplay={false}
                            slidesPerView={1}
                            spaceBetween={28}
                        >

                            {eventsData.map(slide =>
                                <SwiperSlide key={slide.id}>
                                    <div className='stayconnect-card cursor-pointer' onClick={() => event_details(slide.id, slide.eventName)}>
                                        <div className='card-upper'>
                                            <div className='date-col'><h3>{slide.EventDate}</h3><p>{slide.EventMonth}</p></div>
                                            {render_slider(slide)}
                                        </div>
                                        <div className='card-bottom'>
                                            <div className='event-name cursor-pointer' onClick={() => event_details(slide.id, slide.eventName)}>{slide.eventName}</div>

                                            <div className='info-list'>
                                                <div className='list-item'><div className='icons'><SvgIcon name='date-icon' viewbox="0 0 18 20" /></div> {slide.eventStartDay} | {slide.eventStartDate} - {slide.eventEndDate}</div>
                                                <div className='list-item'><div className='icons'><SvgIcon name='time-icon' viewbox="0 0 19 19" /></div> {slide.eventStarTime} - {slide.eventEndTime}</div>

                                                <div className='list-item list-item-address'>
                                                    {slide.eventType == 'online' && (<><div className='icons'><SvgIcon name='video-icon' viewbox='0 0 20.332 13.667' /> </div> Online</>)}
                                                    {slide.eventType == 'offline' && (<><div className='icons'><SvgIcon name='map-icon' viewbox='0 0 16 20' /> </div>  {render_address(slide)} </>)}

                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-action'>
                                            <div className='left-action'><Button onClick={() => event_details(slide.id, slide.eventName)}> I'm Attending</Button></div>
                                            <div className='right-action'>
                                                <Button onClick={() => event_details(slide.id, slide.eventName)}><SvgIcon name='shares-icon' viewbox="0 0 18 15" /></Button>
                                                <Button onClick={() => event_details(slide.id, slide.eventName)}><SvgIcon name='tag-icon' viewbox="0 0 15 18" /></Button>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                            }

                        </Swiper>
                    </div>
                </div>
            }
        </div>
    )
}

function mapStateToProps({ events, user, auth, common }) {
    return { ...events, auth, ...common };
}

function mapDispatchToProps(dispatch) {
    return { ...bindActionCreators({ ...eventActions, ...commonActions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(RightSideBar);


